export default {
    areYouSure:
        'Are you sure you don’t want to downgrade your account to a free account or manage your email preferences instead?',
    autoDeletionWarning:
        'Deleting your user account would also delete the following companies (Set someone else as the owner if you only want to delete your user account.)',
    billingDetails: 'Billing Details',
    changeOwner: '(Click here to change owner)',
    companies: 'Companies',
    deletingYourUser:
        'Deleting your user account would also delete the following companies (Set someone else as the owner if you only want to delete your user account.)',
    errorAtLeastOneCompany:
        'A user account must have at least one company. If you wish to delete all of your companies, you must also delete your user account.',
    errorYouDidNotSelectAnything: 'You did not select anything for deletion.',
    errorYouWantToDeleteYourAccount:
        'You want to delete your account but you own these companies. Please either choose to delete those too, or go to their team member list page to transfer ownership to someone else and then come back to this deletion screen to continue.',
    improvementsLabel:
        'Please let us know if there is any way we can improve our service.',
    notificationSettings: 'Notification Settings',
    reason: 'Please select the main reason for deletion from the following.',
    reasonDetailLabel:
        'Please tell us more details or background of your deletion.',
    selectTheData:
        'If you are sure that you want to continue, select the data that you wish to delete below.',
    selectedReasonLabel:
        'Please select the main reason for deletion from the following.',
    selectedReasonOption1: "We don't create documents that much anymore",
    selectedReasonOption2:
        'We decided to switch to a different product or system',
    selectedReasonOption3: 'MakeLeaps is missing important features',
    selectedReasonOption4: 'We had a bad experience (bugs, designs, etc)',
    selectedReasonOption5: "It's too expensive for us",
    selectedReasonOption6: 'Other',
    title: 'Deletion',
    userAccount: 'User account',
    userAccountDeletionWarning:
        'Deleting your user account would also delete the following companies (Set someone else as the owner if you only want to delete your user account.)',
};
